module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-alert', {
    attrs: {
      "show-icon": "",
      "type": "info1",
      "title": "Please Note",
      "description": "Any updated sites will only disappear on refresh."
    }
  }), _vm._v(" "), _c('data-table', {
    ref: "sitesWithoutLandowners",
    attrs: {
      "table-ref": "sitesWithoutLandownersDataTable",
      "title": "Sites Without Landowners",
      "icon": "fa fa-user-slash",
      "url": "report/property/without/landlords",
      "fields": _vm.fields,
      "detail-component": "site-tenancy-detail-row",
      "search-placeholder": "Site Status, Site Names, Site Groups..."
    },
    scopedSlots: _vm._u([{
      key: "show",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "fa fa-angle-double-down"
          },
          on: {
            "click": function($event) {
              return _vm.showSite(scope.rowData.id)
            }
          }
        }, [_vm._v(" Show")])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e2c16ad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/property/SitesWithoutLandlords.vue
// module id = 1396
// module chunks = 0